import React, { createContext, useContext, useState } from 'react';

const DocumentRequirementContext = createContext();

export const useDocumentRequirement = () => {
  const context = useContext(DocumentRequirementContext);
  if (!context) {
    throw new Error('useDocumentRequirement must be used within a DocumentRequirementProvider');
  }
  return context;
};

export const DocumentRequirementProvider = ({ children }) => {
  // Initialize from localStorage to persist across page refreshes
  const [isCompleted, setIsCompleted] = useState(() => {
    const stored = localStorage.getItem('documentRequirementsCompleted');
    return stored === 'true';
  });
  const [isChecking, setIsChecking] = useState(false);

  const value = {
    isCompleted,
    setIsCompleted: (value) => {
      setIsCompleted(value);
      // Also update localStorage for persistence
      if (value) {
        localStorage.setItem('documentRequirementsCompleted', 'true');
      } else {
        localStorage.removeItem('documentRequirementsCompleted');
      }
    },
    isChecking,
    setIsChecking
  };

  return (
    <DocumentRequirementContext.Provider value={value}>
      {children}
    </DocumentRequirementContext.Provider>
  );
};
